import styled from 'styled-components';

const Background = styled.section`
  background-color: black;
  padding: 2% 0;
`;

export default Background;
